import { theme } from "styles/theme";
import { ResolvedTheme, useThemeMode } from "context/ThemeModeContext";

/** Sensor series colors aligned with Davey chart tokens. */
export const CHART_COLORS = {
  pH: theme.colors.chart.blue,
  ORP: theme.colors.chart.amber,
  Temperature: theme.colors.chart.emerald,
  Salinity: theme.colors.chart.teal,
  Flow: theme.colors.chart.tealDark,
  Vsdw: theme.colors.error,
} as const;

const CHART_UI_BY_MODE = {
  light: {
    axis: "#6C757D",
    grid: "rgba(0, 116, 122, 0.12)",
    title: "#00747A",
    tooltipBg: "#FFFFFF",
    tooltipBorder: "#00747A",
    tooltipTitle: "#00747A",
    tooltipBody: "#212529",
  },
  dark: {
    axis: "#ADB5BD",
    grid: "rgba(61, 157, 162, 0.2)",
    title: "#3D9DA2",
    tooltipBg: "#2A2A2A",
    tooltipBorder: "#3D9DA2",
    tooltipTitle: "#3D9DA2",
    tooltipBody: "#F5F5F5",
  },
} as const;

type ChartUi = (typeof CHART_UI_BY_MODE)[ResolvedTheme];

function getChartUi(resolved: ResolvedTheme = "light"): ChartUi {
  return CHART_UI_BY_MODE[resolved];
}

export function useChartUi(): ChartUi {
  const { resolved } = useThemeMode();
  return getChartUi(resolved);
}
